import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField } from "@mui/material";
import { Grid } from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import { yupResolver } from '@hookform/resolvers/yup';
// import DoneDialog from '../../Components/Modals/DoneDialog';
import * as Yup from 'yup';
import { cloaseDonePopup, EditProductTableError, EditProductTableStart, EditProductTableSuccess, openErrorDialog } from "../../Redux/Actions/InputData";
import { API_BASE_URL, EDIT_MANUFACTURING_MASTER_2_TABLE_API } from "../../Utils/Config";
import { putRequest } from "../../Services/AxiosConfiguration";
import _ from "underscore";
import "./style.css";
import { useState } from "react";
import { useForm } from "react-hook-form";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function EditModal(props: any) {
   
    const { editedData } = props;
  
    const dispatch: any = useDispatch();    
    const [isDone, setIsDone] = useState(false);

    const handleCloseDonePopup = () => {
        editedData.max_no_of_shifts = props?.resetValues?.max_no_of_shifts;
        editedData.max_no_of_changeovers = props?.resetValues?.max_no_of_changeovers;     
        props.onClose();
        // setIsDone(false);
        // dispatch(cloaseDonePopup());
    };

    const validationSchema = Yup.object().shape({
        max_no_of_shifts: Yup.string().required('Max no of Shifts is required'),
        max_no_of_changeovers: Yup.string().required('Max no of change over is required')
    });

    const { register, control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data: any) => {
        // const requestParam = { "table": "Manufacturing_2_data", "id": props.editedData.id, "values": { "Max no of Shifts": data["Max no of Shifts"], "Max no of change over": data["Max no of change over"] } };
        dispatch(EditProductTableStart());
        const urls = API_BASE_URL + EDIT_MANUFACTURING_MASTER_2_TABLE_API;
        const header = {accept: "application/json", "Content-Type": "application/json"};
        putRequest(urls, editedData, header, {}).then((response) => {
            if (response.status === 200) {
                dispatch(EditProductTableSuccess(response.data));
            }
        }).catch((error) => {
            dispatch(openErrorDialog(error));
            dispatch(EditProductTableError(error));
        });
        setTimeout(() => {
            props.onClose();
        }, 200);
    };
    return (
        <>
            <BootstrapDialog className="edit-dialog" onClose={props.onClose} aria-labelledby="customized-dialog-title" open={props.isOpen}>
                <div className="modal-header">
                    <Grid container spacing={1}>
                        <Grid item xs={10} md={10} lg={10}>
                            <h3>{props.headerName}</h3>
                            <span className="title-note">Edit table content</span>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <CancelIcon className="cancel-icon" onClick={props.onClose} />
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <DialogContent className="modal-body">
                        <form>
                            <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6} md={6} lg={6}>
                                    <TextField type="text" label="Factory Code" variant="outlined" defaultValue={editedData.factory_Code} disabled />
                                </Grid>
                                <Grid container item sm={6}>
                                    <TextField type="text" label="Factory" variant="outlined" defaultValue={editedData.factory} disabled />
                                </Grid>
                            </Grid>

                            <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6} md={6} lg={6}>
                                    <TextField type="text" label="Cascade" variant="outlined" defaultValue={editedData.cascade} disabled />
                                </Grid>
                                <Grid container item sm={6}>
                                    <TextField type="text" label="Line" variant="outlined" defaultValue={editedData.line} disabled />
                                </Grid>
                            </Grid>
                           

                            <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6}>
                                    <TextField onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()} type="number" label="Max no of Shifts" variant="outlined" {...register("max_no_of_shifts")} required error={errors["max_no_of_shifts"] ? true : false} defaultValue={editedData.max_no_of_shifts} onChange={(e) => editedData.max_no_of_shifts = e.target.value} />
                                </Grid>
                                <Grid container item sm={6}>
                                    <TextField onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()} type="number" label="Max no of change over" variant="outlined" {...register("max_no_of_changeovers")} required error={errors["max_no_of_changeovers"] ? true : false} defaultValue={editedData.max_no_of_changeovers} onChange={(e) => editedData.max_no_of_changeovers = e.target.value} />
                                </Grid>
                            </Grid>
                            <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6}>
                                    <div className="error-msg">
                                        {errors.max_no_of_shifts ? 'Invalid Max no of Shifts' : false}
                                    </div>
                                </Grid>
                                <Grid container item sm={6}>
                                    <div className="error-msg">
                                        {errors.max_no_of_changeovers ? 'Invalid Max no of change over' : false}
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6} md={6} lg={6}>
                                    <TextField type="text" label="Changeover Shift" variant="outlined" defaultValue={editedData.changeover_Shift} disabled />
                                </Grid>
                             
                            </Grid>

                            {/* <Grid direction='row' container spacing={2} mb={2}>
                                <Grid container item sm={6}>
                                    <TextField type="text" label="Pack" variant="outlined" defaultValue={editedData.Pack} disabled />
                                </Grid>
                            </Grid> */}
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <div className="modal-action">
                            <Button variant="outlined" className="cancel" onClick={handleCloseDonePopup}>Cancel</Button>
                            {/* <Button variant="contained" className="save" onClick={(e) => {handleSave(editedData, props);}}>Save Table Row</Button> */}
                            <Button variant="contained" className="save" onClick={handleSubmit(onSubmit)}>Save Table Row</Button>
                        </div>
                    </DialogActions>
                </div>
            </BootstrapDialog>

            {/* <Dialog
                className="edit-dialog"
                open={props.isOpen}
                onClose={props.onClose}
                aria-labelledby="edit-dialog-title"
                aria-describedby="edit-dialog-description"
                //fullScreen={true}
                //fullWidth={true}
                maxWidth="lg"
                //PaperProps={{ sx: { width: "30%", height: "100%" } }}
                sx={{
                "& .MuiDialog-container": {
                    justifyContent: "flex-start",
                    alignItems: "flex-start"
                }
                }}
                PaperProps={{
                sx: {
                    m: 0,
                    top: 10,
                    left: 10
                }
                }}
                //PaperProps={{ sx: { position: "fixed", top: 10, left: 10, m: 0 } }}
            >
                <DialogTitle id="edit-dialog-title">
                    <div className="modal-header">
                        <Grid container spacing={1} mt={2}>
                            <Grid item xs={10} md={10} lg={10}>
                                <h3>Manufacturing Master 1 Table</h3>
                                <span className="title-note">Edit table content</span>
                            </Grid>
                            <Grid item xs={2} md={2} lg={2}>
                                <CancelIcon className="cancel-icon" onClick={props.onClose} />
                            </Grid>
                        </Grid>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <form>
                        <Grid direction='row' container spacing={2} mb={2}>
                            <Grid container item sm={6} md={6} lg={6}>
                                <TextField type="text" label="Factory" variant="outlined" value={editedData.Factory} disabled />
                            </Grid>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Cascade Number" variant="outlined" value={editedData.CascadeNo} disabled />
                            </Grid>
                        </Grid>

                        <Grid direction='row' container spacing={2} mb={2}>
                            <Grid container item sm={6} md={6} lg={6}>
                                <TextField type="text" label="Line" variant="outlined" value={editedData.Line} disabled />
                            </Grid>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Back Pack" variant="outlined" value={editedData.Basepack} disabled />
                            </Grid>
                        </Grid>

                        <Grid direction='row' container spacing={2} mb={2}>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Grammage" variant="outlined" value={editedData.Grammage} />
                            </Grid>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Design Speed" variant="outlined" value={editedData.DesignSpeed} />
                            </Grid>
                        </Grid>

                        <Grid direction='row' container spacing={2} mb={2}>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Factory Code" variant="outlined" value={editedData.Factorycode} disabled />
                            </Grid>
                            <Grid container item sm={6}>
                                <TextField type="text" label="Format" variant="outlined" value={editedData.Format} disabled />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" className="cancel" onClick={props.onClose}>Cancel</Button>
                    <Button variant="contained" className="save" onClick={props.handleSave}>Save Table Row</Button>
                </DialogActions>
            </Dialog> */}
        </>
    );
}

export default EditModal;
